import { rem } from 'polished'
import styled from 'styled-components'

const ItemPriceAndCTAs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(16)};
  align-items: end;

  &:empty {
    display: none;
  }

  > .price-area {
    flex-basis: auto;
  }

  > .cta-area {
    flex-basis: auto;
    margin-left: auto;
    text-align: right;
  }
`

export default ItemPriceAndCTAs
